import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {Loner} from "../../../Loner";
import {gsap} from "gsap";
import {LonerSymbol} from "../../../reels/symbols/main/LonerSymbol";
import {LonerSound} from "../../../sound/LonerSound";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";

export class LonerXWaysPresentation implements SimplePresentation {

    private _mainTL: gsap.core.Timeline;
    private _controller: SimplePresentationRunnerController;
    private static _symbolInfectedAnimations: string[] = ["infected_1", "infected_2", "infected_3", "infected_4"];
    private static _animationsUsed: number[] = [];

    constructor() {
    }

    public static getInfectedAnimationName(): string {
        let animationIndex: number = MathHelper.randomNumberInRange(0, this._symbolInfectedAnimations.length - 1);
        if (this._animationsUsed.length == 0 || this._animationsUsed.length == this._symbolInfectedAnimations.length) {
            this._animationsUsed = [];
            this._animationsUsed.push(animationIndex);
        } else {
            while (this._animationsUsed.includes(animationIndex)) {
                animationIndex = MathHelper.randomNumberInRange(0, this._symbolInfectedAnimations.length - 1);
            }
            this._animationsUsed.push(animationIndex);
        }

        return this._symbolInfectedAnimations[animationIndex];
    }

    shouldRun(): boolean {
        return Loner.model.xWaysInfo.length > 0;
    }

    start(controller: SimplePresentationRunnerController): void {
        let otherThanItselfInfected: boolean = false;
        this._controller = controller;

        this._mainTL = gsap.timeline();
        this._mainTL.add(() => controller.setSkipCallback(() => this.skip()));
        const scatterInfectTLs: gsap.core.Timeline[] = [];
        let subScatterInfectTL: gsap.core.Timeline;
        for (let i: number = 0; i < Loner.model.xWaysInfo.length; i++) {
            subScatterInfectTL = gsap.timeline();
            subScatterInfectTL.add(Loner.scatterPool.getScatterSymbolOnReel(Loner.model.xWaysInfo[i].pos[0]).getInfectiousTL(Loner.model.xWaysInfo[0].symConvertedTo));
            scatterInfectTLs.push(subScatterInfectTL);
        }
        this._mainTL.add(scatterInfectTLs);

        const symbolInfectiousTLs: gsap.core.Timeline[] = [];
        let tempSymbol: LonerSymbol;
        let subSymbolInfectiousTL: gsap.core.Timeline;
        for (let i: number = 0; i < 5; i++) {
            for (let j: number = 0; j < 3; j++) {
                tempSymbol = (<LonerSymbol>Loner.allReelView.mainReelModels[i].reelView.symbols[j + 3]);
                if (tempSymbol.symbolName == Loner.model.xWaysInfo[0].symConvertedTo && tempSymbol.bigSymbolPart == false) {
                    subSymbolInfectiousTL = gsap.timeline();
                    subSymbolInfectiousTL.add(tempSymbol.getShowInfectiousSplatTL());
                    if (!otherThanItselfInfected) {
                        subSymbolInfectiousTL.add(() => {
                            Loner.soundPlayer.playSound(LonerSound.TV_INFECT_LAST);
                        }, "<");
                        otherThanItselfInfected = true;
                    }
                    symbolInfectiousTLs.push(subSymbolInfectiousTL);
                }
            }
        }

        this._mainTL.add(symbolInfectiousTLs, "-=1");

        if (Loner.autoPlayPlugin.isAutoplayRound == true && Loner.model.betWayWins.length == 0){
            this._mainTL.add(gsap.timeline({delay:0.4}));
        }

        this._mainTL.add(() => {
            this.complete();
        }, "-=0.5");
    }

    private skip(): void {
        this._mainTL.totalProgress(1);
    }

    private complete(): void {
        this._controller.finish();
    }
}